/** General Info row uses seven columns; connection fields pack into the same grid. */
export const GENERAL_INFO_COLUMN_COUNT = 7;

export const STREAM_OPTIONS_TAB_LABEL = "Stream Options";

export const generalInfoTableCellSx = {
  fontFamily: "Mulish",
  verticalAlign: "top" as const,
};

export const connectionFieldTextFieldSx = { width: 150 };

export const packIntoRows = <T>(
  items: T[],
  columnCount = GENERAL_INFO_COLUMN_COUNT
): (T | null)[][] => {
  if (items.length === 0) {
    return [];
  }
  const rows: (T | null)[][] = [];
  for (let index = 0; index < items.length; index += columnCount) {
    const row: (T | null)[] = items.slice(index, index + columnCount);
    while (row.length < columnCount) {
      row.push(null);
    }
    rows.push(row);
  }
  return rows;
};
